export const partnerActionTypes = {
	SAVE_PARTNER_INFO: "SAVE_PARTNER_INFO"
};
